import { Flame } from "lucide-react";
import { Wordmark } from "./Wordmark";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="bg-slate-950 text-slate-400 border-t border-slate-800">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
              <Flame className="w-4 h-4 text-white" />
            </div>
            <Wordmark onDark size="sm" />
          </div>
          <p className="text-sm max-w-sm leading-relaxed">
            Train smarter for the firehouse. Exam-grade question banks and an AI oral board simulator built for aspiring firefighters and EMTs.
          </p>
        </div>
        <div>
          <h4 className="font-heading text-white text-lg mb-3">Platform</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/study" className="hover:text-primary">Study Bank</Link></li>
            <li><Link to="/interview" className="hover:text-primary">Mock Oral Board</Link></li>
            <li><Link to="/pricing" className="hover:text-primary">Pricing</Link></li>
            <li><Link to="/departments" className="hover:text-primary">Fire department directory</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading text-white text-lg mb-3">Guides</h4>
          <ul className="space-y-2 text-sm" data-testid="footer-guides">
            <li><Link to="/firefighter-hiring-process" className="hover:text-primary" data-testid="footer-guide-hiring-process">Firefighter Hiring Process</Link></li>
            <li><Link to="/firefighter-mock-oral-board" className="hover:text-primary" data-testid="footer-guide-mock-oral-board">Firefighter Mock Oral Board</Link></li>
            <li><Link to="/firefighter-practice-test" className="hover:text-primary" data-testid="footer-guide-practice-test">Firefighter Practice Test</Link></li>
            <li><Link to="/firefighter-oral-board-prep" className="hover:text-primary" data-testid="footer-guide-oral-board">Firefighter Oral Board Preparation</Link></li>
            <li><Link to="/firefighter-oral-board-questions" className="hover:text-primary" data-testid="footer-guide-oral-board-questions">Firefighter Oral Board Questions</Link></li>
            <li><Link to="/firefighter-interview-practice" className="hover:text-primary" data-testid="footer-guide-interview">Firefighter Interview Practice</Link></li>
            <li><Link to="/how-to-prepare-firefighter-interview" className="hover:text-primary" data-testid="footer-guide-interview-prep">How to Prepare for a Firefighter Interview</Link></li>
            <li><Link to="/firefighter-resume-examples" className="hover:text-primary" data-testid="footer-guide-resume">Firefighter Resume Examples</Link></li>
            <li><Link to="/firefighter-station-visit-questions" className="hover:text-primary" data-testid="footer-guide-station-visit">Firefighter Station Visit Questions</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading text-white text-lg mb-3">Exam Tracks</h4>
          <ul className="space-y-2 text-sm">
            <li>NREMT / EMT</li>
            <li>Firefighter I & II</li>
            <li>Promotional / Captain</li>
          </ul>
        </div>
      </div>
      <div className="mt-10 pt-6 border-t border-slate-800 text-xs text-slate-500 flex flex-col sm:flex-row justify-between gap-2">
        <span>© {new Date().getFullYear()} First Step. For training purposes.</span>
        <span>Built for the brave.</span>
      </div>
    </div>
  </footer>
);
